// revert-LSW-157
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
// Dependecies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Accordion } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Moment from 'react-moment';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DatePicker, Pagination } from 'antd';
import 'antd/dist/antd.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// Components
import { withTranslation } from 'react-i18next';
import Template from '../../components/Template';
import Spinner from '../../components/Spinner';
import RenderTooltip from '../../components/RenderTooltip';
import QuotationImagesList from '../../components/Maintenance/QuotationImagesList';
import TableSelectedParts from '../../components/TableSelectedParts';
import AdditionalApprovalsHistory from '../../components/Maintenance/AdditionalApprovalsHistory';
// Hooks
import useMaintenanceHistory from '../../hooks/useMaintenanceHistory';
import useStatusService from '../../hooks/useStatusService';
// Images
import arrowDown from '../../../sass/images/icons/arrow-down.svg';
import arrowUp from '../../../sass/images/icons/arrow-up.svg';
import calendarIcon from '../../../sass/images/icons/calendar-day.svg';
import notMaintenanceHistory from '../../../sass/images/mantenanceHistory/not-maintenance-history.svg';
import eye from '../../../sass/images/ver-ocultar.svg';
// Utils
import { urlPublicS3 } from '../../helpers';

function MaintenanceHistory(props) {
  const {
    maintenanceHistorys,
    dateInitial,
    dateFinal,
    useSetFilterDate,
    onChangeInitial,
    onChangeFinal,
    currentPage,
    cardPerPage,
    handleChange,
    minIndex,
    maxIndex,
    reload,
    dataHistorys,
    CustomToggle,
    newFilter,
  } = useMaintenanceHistory();
  const { newMaintenances } = useStatusService();
  const [activeKey, setActiveKey] = useState(0);
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
  const { t } = props;
  const hourChange = (time) => moment(time, 'hh:mm a');
  return (
    <Template
      type={3}
      newMaintenances={newMaintenances}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      {!reload ? (
        <Spinner text={t('alert:reload')}> </Spinner>
      ) : (
        <>
          {!dataHistorys ? (
            <>
              <div className="content_dynamic history">
                <Row className="content_history">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">{t('title')}</h1>
                    </div>
                  </div>
                  <div className="not-services">
                    <img
                      src={notMaintenanceHistory}
                      className="img-not-maintenances"
                      alt={t('alt:not_mantenice')}
                    />
                    <h4 className="center">{t('alert1')}</h4>
                  </div>
                </Row>
              </div>
            </>
          ) : (
            <div className="content_dynamic history">
              <Row className="content_history">
                <div className="header-content">
                  <div className="info-tittle">
                    <h1 className="title-maintenances">{t('title')}</h1>
                  </div>
                  <div className="info-notification">
                    <div className="img-container">
                      <p className="tittle-container">{t('total-maintenace')}</p>
                      <h5 className="value-container">{maintenanceHistorys.length}</h5>
                    </div>
                  </div>
                </div>
                <div className="modal-display row-states">
                  <div className="tittle-filter">
                    <p className="bold txt spacy-top">{t('filter')}</p>
                  </div>
                  <div className="block-datepicker">
                    <div className="input-filter">
                      <label htmlFor="name" className="col-form-label">
                        {t('date-initial')}
                      </label>
                      <br />
                      <DatePicker
                        showToday
                        value={dateInitial}
                        defaultValue={dateInitial}
                        format={dateFormatList}
                        selected={dateInitial}
                        suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                        placeholder=""
                        onChange={onChangeInitial}
                      />
                    </div>
                    <div className="input-filter">
                      <label htmlFor="name" className="col-form-label">
                        {t('date-final')}
                      </label>
                      <br />
                      <DatePicker
                        showToday
                        value={dateFinal}
                        defaultValue={dateFinal}
                        format={dateFormatList}
                        selected={dateFinal}
                        suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                        placeholder=""
                        onChange={onChangeFinal}
                      />
                    </div>
                  </div>
                  <div className="button-filter">
                    <Button
                      className="btn-filter gray"
                      variant="light"
                      onClick={() => useSetFilterDate(true)}
                    >
                      {t('filter-buttom')}
                    </Button>
                  </div>
                </div>
              </Row>
              <Row className="no-gutters">
                {maintenanceHistorys.length <= 0 ? (
                  <div className="content_not_mantenaice ">
                    <img
                      src={notMaintenanceHistory}
                      className="img-not-maintenances small"
                      alt={t('alt:not_mantenice')}
                    />
                    <h4>{t('alert2')}</h4>
                    <Button
                      className="btn-orange"
                      style={{ width: '250px', padding: '0px' }}
                      variant="light"
                      onClick={() => newFilter()}
                    >
                      {t('buttom-alert2')}
                    </Button>
                  </div>
                ) : (
                  <>
                    <Accordion className="col-12">
                      {maintenanceHistorys.map(
                        (maintenanceHistory, index) =>
                          index >= minIndex &&
                          index < maxIndex && (
                            <div key={index}>
                              <Card key={maintenanceHistory.id} className="main-card">
                                <div
                                  className={`borde-status status-${maintenanceHistory.id_status}`}
                                />
                                <Card.Header
                                  className={`card-maintenances ${
                                    activeKey === maintenanceHistory.id
                                      ? 'head-show'
                                      : 'head-hidden'
                                  } workshop-card`}
                                >
                                  <Row>
                                    <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                      <CustomToggle
                                        as={Button}
                                        eventKey={maintenanceHistory.id}
                                        handleClick={() => {
                                          if (activeKey === maintenanceHistory.id) {
                                            setActiveKey(null);
                                          } else {
                                            setActiveKey(maintenanceHistory.id);
                                          }
                                        }}
                                      >
                                        <p className="title-2">{t('maintenance:license-plate')}</p>
                                        <p className="txt">
                                          {maintenanceHistory.vehicle.licenseplate}
                                          <OverlayTrigger
                                            placement="top"
                                            className="tooltip-info vehicle"
                                            id="vehicle"
                                            delay={{ show: 50, hide: 500 }}
                                            overlay={(componentProps) =>
                                              RenderTooltip({
                                                ...componentProps,
                                                text: `${t('maintenance:brand')}`,
                                                text2: `${t('maintenance:model')}`,
                                                text3: `${t('maintenance:color')}`,
                                                brand: maintenanceHistory.vehicle.brand.name,
                                                model: maintenanceHistory.vehicle.model.name,
                                                color: maintenanceHistory.vehicle.color,
                                                id: 'tooltip-info-vehicle',
                                                classtxt: 'tooltip-txt-info',
                                              })
                                            }
                                          >
                                            <img
                                              className="info-maintenance-company"
                                              src={eye}
                                              alt={t('alt:tooltip')}
                                            />
                                          </OverlayTrigger>
                                        </p>
                                      </CustomToggle>
                                    </Col>
                                    <Col className="col-head" xs={6} sm={3} md={3} lg={4} xl={4}>
                                      <CustomToggle
                                        as={Button}
                                        eventKey={maintenanceHistory.id}
                                        handleClick={() => {
                                          if (activeKey === maintenanceHistory.id) {
                                            setActiveKey(null);
                                          } else {
                                            setActiveKey(maintenanceHistory.id);
                                          }
                                        }}
                                      >
                                        <p className="title-2">
                                          {t('maintenance:date-hour-request')}
                                        </p>
                                        <p className="txt">
                                          <Moment format="DD/MM/YYYY hh:mm a">
                                            {maintenanceHistory.created_at}
                                          </Moment>
                                        </p>
                                      </CustomToggle>
                                    </Col>
                                    <Col className="col-head" xs={6} sm={3} md={3} lg={3} xl={4}>
                                      <p className="second title-2">{t('status')}</p>
                                      <p className={`txt color-${maintenanceHistory.id_status}`}>
                                        {maintenanceHistory.status.status}
                                      </p>
                                    </Col>
                                    <div className="toggle-icon">
                                      <CustomToggle
                                        as={Button}
                                        eventKey={maintenanceHistory.id}
                                        handleClick={() => {
                                          if (activeKey === maintenanceHistory.id) {
                                            setActiveKey(null);
                                          } else {
                                            setActiveKey(maintenanceHistory.id);
                                          }
                                        }}
                                      >
                                        {activeKey === maintenanceHistory.id ? (
                                          <img src={arrowUp} alt={t('alt:hidden_information')} />
                                        ) : (
                                          <img src={arrowDown} alt={t('alt:show_information')} />
                                        )}
                                      </CustomToggle>
                                    </div>
                                  </Row>
                                </Card.Header>

                                <Accordion.Collapse eventKey={maintenanceHistory.id}>
                                  <Card.Body className="description-card">
                                    <div className="block-observations">
                                      <Row>
                                        <Col xs={12} md={12} className="col-collapse">
                                          <h6 className="bold">{t('observations')}</h6>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={3} className="col-collapse">
                                          <p className="second title-2">
                                            {t('maintenanceCompany:name-workshop')}
                                          </p>
                                          <p className="txt">
                                            {maintenanceHistory.garage_worshop
                                              ? maintenanceHistory.garage_worshop.workshop
                                              : ''}
                                          </p>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={12} className="col-collapse">
                                          <p className="second title-2">
                                            {t('maintenanceCompany:observations-mechanics')}
                                          </p>
                                          <p className="txt observations-mechanics">
                                            {maintenanceHistory.mechanics_observations}
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col xs={12} md={12}>
                                          <h6 className="bold">
                                            {t('maintenanceCompany:observations')}
                                          </h6>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={3} className="col-collapse">
                                          <p className="title-2">{t('maintenance:name')}</p>
                                          <p className="txt">
                                            {`${maintenanceHistory.driver.name} ${maintenanceHistory.driver.last_name}`}
                                          </p>
                                        </Col>
                                        <Col xs={12} md={3} className="col-collapse">
                                          <p className="title-2">
                                            {t('maintenanceCompany:service-type')}
                                          </p>
                                          <p className="txt">
                                            {maintenanceHistory.service_type.split(',')[0]}
                                            {maintenanceHistory.service_type.split(',').length >
                                            1 ? (
                                              <OverlayTrigger
                                                placement="top"
                                                className="tooltip-info vehicle"
                                                id="vehicle"
                                                delay={{ show: 50, hide: 500 }}
                                                overlay={(componentProps) =>
                                                  RenderTooltip({
                                                    ...componentProps,
                                                    items:
                                                      maintenanceHistory.service_type.split(','),
                                                    id: 'tooltip-type-services',
                                                    classtxt: 'tooltip-txt-info',
                                                  })
                                                }
                                              >
                                                <img
                                                  className="info-maintenance-company"
                                                  src={eye}
                                                  alt={t('alt:tooltip')}
                                                />
                                              </OverlayTrigger>
                                            ) : (
                                              ''
                                            )}
                                          </p>
                                        </Col>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="title-2">
                                            {t('maintenance:date-hour-service')}
                                          </p>
                                          <p className="txt">
                                            <Moment format="DD/MM/YYYY">
                                              {maintenanceHistory.date_service}
                                            </Moment>{' '}
                                            <Moment
                                              date={hourChange(maintenanceHistory.service_hours)}
                                              format="hh:mm a"
                                            />
                                          </p>
                                        </Col>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('maintenance:image')}</p>
                                          <p className="txt">
                                            {maintenanceHistory.image ? (
                                              <a
                                                className="a-vehicle"
                                                href={`${urlPublicS3()}/${
                                                  maintenanceHistory.image
                                                }`}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                {t('maintenance:see-image')}
                                              </a>
                                            ) : (
                                              t('maintenance:without-image')
                                            )}
                                          </p>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col xs={12} md={12} className="col-collapse">
                                          <p className="second title-2">
                                            {t('maintenanceCompany:description-card')}
                                          </p>
                                          <p className="txt observations-mechanics">
                                            {maintenanceHistory.description}
                                          </p>
                                        </Col>
                                      </Row>
                                      <hr></hr>
                                      <Row>
                                        <QuotationImagesList quotation={maintenanceHistory.quotation} title="Cotización" status={maintenanceHistory.status.id_status} />
                                        <QuotationImagesList quotation={maintenanceHistory.img_quotation} title="Imágenes que concuerden con lo cotizado*" status={maintenanceHistory.status.id_status}/>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('maintenance:aviso')}</p>
                                          <p>{(maintenanceHistory.aviso?maintenanceHistory.aviso:'N/A')}</p>
                                        </Col>
                                        <Col xs={6} md={3} className="col-collapse">
                                          <p className="second title-2">{t('maintenance:comentarios')}</p>
                                          <p>{(maintenanceHistory.comments?maintenanceHistory.comments:'N/A')}</p>
                                        </Col> 
                                      </Row>
                                      <Row>
                                        <hr></hr>
                                        <QuotationImagesList quotation={maintenanceHistory.workshop_images} title="Imágenes después del servicio" status={maintenanceHistory.status.id_status}/>
                                      </Row>
                                      <Row>
                                        <TableSelectedParts parts={(() => {
                                          const base = maintenanceHistory.selected_num_part ? JSON.parse(maintenanceHistory.selected_num_part) : [];
                                          const map = {};
                                          base.forEach((p) => { map[String(p.id)] = { ...p, quantity: Number(p.quantity) }; });
                                          (maintenanceHistory.additional_approvals || [])
                                            .filter((a) => a.status === 'approved')
                                            .forEach((a) => {
                                              const aParts = typeof a.selected_num_part === 'string'
                                                ? JSON.parse(a.selected_num_part || '[]')
                                                : (a.selected_num_part || []);
                                              aParts.forEach((ap) => {
                                                const id = String(ap.id);
                                                const qty = Number(ap.quantity);
                                                if (map[id]) { map[id] = { ...map[id], quantity: map[id].quantity + qty }; }
                                                else if (qty > 0) { map[id] = { ...ap, quantity: qty }; }
                                              });
                                            });
                                          return Object.values(map).filter((p) => p.quantity > 0);
                                        })()} />
                                      </Row>
                                      {maintenanceHistory.additional_approvals && maintenanceHistory.additional_approvals.length > 0 && (
                                        <AdditionalApprovalsHistory
                                          approvals={maintenanceHistory.additional_approvals}
                                          serviceId={maintenanceHistory.id}
                                        />
                                      )}
                                    </div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            </div>
                          )
                      )}
                    </Accordion>
                    <Pagination
                      align="center"
                      className="col-12"
                      size="small"
                      defaultCurrent={1}
                      total={maintenanceHistorys.length}
                      defaultPageSize={cardPerPage}
                      current={currentPage}
                      onChange={handleChange}
                    />
                  </>
                )}
              </Row>
            </div>
          )}
        </>
      )}
    </Template>
  );
}

MaintenanceHistory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['maintenanceHistory', 'maintenance', 'maintenanceCompany', 'alt'])(
  MaintenanceHistory
);
